module.exports = __webpack_public_path__ + "f6aa6c4e978d9b617c074b52d88d6290.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./app/fonts/flaticon.eot
 ** module id = 5
 ** module chunks = 0
 **/